import { render, staticRenderFns } from "./editPasswordForm.vue?vue&type=template&id=5bccabc8&"
import script from "./editPasswordForm.vue?vue&type=script&lang=js&"
export * from "./editPasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./editPasswordForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "editPasswordForm.vue"
export default component.exports